export default __webpack_public_path__ + "static/media/pvc.a0005e21.svg";